import { render, staticRenderFns } from "./auditRecord.vue?vue&type=template&id=0682e988&scoped=true"
import script from "./auditRecord.vue?vue&type=script&lang=js"
export * from "./auditRecord.vue?vue&type=script&lang=js"
import style0 from "./auditRecord.vue?vue&type=style&index=0&id=0682e988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0682e988",
  null
  
)

export default component.exports